import collectiveSetting from './collective-settings'
import gatewayForm from './gateway-form'
import collectiveGateways from './collective-gateways'
import generalCollectiveSetting from './general-collective-settings'

export {
    collectiveSetting,
    gatewayForm,
    collectiveGateways,
    generalCollectiveSetting,
}